export const iconFontAwesomeClothingFashionSocks = (
	<i className="fa-solid fa-socks"></i>
);
